import React from 'react';
import { Box, Container, CircularProgress } from '@mui/material';
import EventCardList from './Components/EventCardList';
import PlannerCalendar from './Components/PlannerCalendar';
import UserCardList from './Components/UserCardList';
import PlannerHeader from './Components/PlannerHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/types';
import { RouteComponentProps } from 'react-router-dom';

const ScheduledServicesPlanner: React.FC<RouteComponentProps> = (props) => {
  const loadingUsers = useSelector((state: RootState) => state.scheduledServices.loadingUsers);
  const loadingServices = useSelector((state: RootState) => state.scheduledServices.loadingServicesForScheduling);
  const loadingPost = useSelector((state: RootState) => state.scheduledServices.loadingPostScheduledService);
  const loadingDelete = useSelector((state: RootState) => state.scheduledServices.loadingSoftDeleteService);

  const goToEquipmentPage = (equipmentId: string) => props.history.push(`/form-equip/${equipmentId}/scheduled-services-planner`);
  const goToEquipmentServicesPage = (equipmentId: string) => props.history.push(`/form-equip-services/${equipmentId}/admin-gestao-equip`);

  const loading = loadingDelete || loadingPost || loadingServices || loadingUsers;
  return (
    <Container maxWidth='xl'>
      <PlannerHeader />
      <Box sx={{...styles.container, opacity: loading ? 0.3 : 1 }}> 
        { loading && <CircularProgress
          variant="indeterminate"
          disableShrink
          size={40}
          thickness={4}
          sx={styles.spinner}
        />}
        <Box sx={styles.usersCalendarContainer}>
          <UserCardList />
          <Box sx={styles.calendarContainer}>
            <PlannerCalendar redirect={goToEquipmentServicesPage}/>
          </Box>
        </Box>
        <EventCardList goToEquipmentPage={goToEquipmentPage} />
      </Box>
    </Container> 
  )
};

export default ScheduledServicesPlanner;

const styles = {
  container: {
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-start',
  },
  calendarContainer: {
    display: 'flex',
    width: '63%',
    maxWidth: '20rem',
  },
  spinner: {
    position: 'absolute',
    top: '15%',
    left: '50%',
    zIndex: 999
  },
  usersCalendarContainer: {
    display: 'flex',
    maxHeight: '800px',
    overflowY: 'auto',
    width: '80%',
  },
}
